export class CodeInfo {
  email: String;
  code: String;
  password: String;
}
